<template>
  <res-select ref="selector" class="template-selector" :readonly="readonly" v-model="selectedTemplate" :items="templates" :attach="attach" :menuProps="menuProps" :loading="loading" return-object></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import templateService from '@/services/template';

  export default {
    name: 'templateSelector',
    components: {
      ResSelect
    },
    data() {
      return {
        templates: [],
        loading: true,
      }
    },
    props: {
      value: {
        required: true
      },
      attach: {
        default: '.template-selector'
      },
      readonly: {
        type: Boolean,
        default: false
      },
      propertyId: {
        required: true
      },
      menuProps: {
        default: () => {}
      }
    },
    methods: {
      async loadTemplates() {
        this.loading = true;
        if (this.propertyId && this.propertyId.length == 36 /* guid length */) {
          let templateData = await templateService.getDropdownByPropertyId(this.propertyId);
          if (templateData && templateData.data) {
            this.templates = templateData.data;
          } else {
            this.templates = [];
          }
        } else {
          this.templates = [];
        }
        this.loading = false;

        // select the default template if no template is selected
        if (!this.value && this.templates && this.templates.length > 0) {
          this.$refs.selector.selectItem(this.templates[0])
          this.$emit("input", this.templates[0])
        }
      },
      selectItem(item) {
        this.$refs.selector.selectItem(item)
      }
    },
    computed: {
      selectedTemplate: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      }
    },
    async mounted() {
      await this.loadTemplates();
    },
    watch: {
      async propertyId(newVal, oldVal) {
        if (newVal != oldVal) {
          await this.loadTemplates();
        }
      }
    }
  }
</script>
